const testimonials = [
  {
    name: "Rachel T.",
    location: "Plantation, FL",
    rating: 5,
    text: "We live near Central Park and booked a Royal Caribbean cruise from Port Everglades for spring break. I checked our passports the week before we were supposed to leave and realized my son's had expired five months earlier. I called Fast Passport Center in a panic. They walked me through exactly what to do, I shipped everything overnight from the UPS Store near Sawgrass Mills, and his passport arrived in three business days. We made the cruise. I honestly don't know what we would have done without them.",
    service: "Child Passport",
  },
  {
    name: "David K.",
    location: "Plantation, FL",
    rating: 5,
    text: "I'm a healthcare consultant based near Nova Southeastern University and fly to Toronto and Mexico City regularly for client meetings. My passport expired two weeks before a trip I had been planning for months. I started the process with Fast Passport Center on a Tuesday, shipped my documents Wednesday morning from the FedEx on Broward Boulevard, and had my new passport by Friday. Unbelievable service. I've since recommended them to three colleagues at the medical center.",
    service: "Passport Renewal",
  },
  {
    name: "The Hernandez Family",
    location: "Plantation, FL",
    rating: 5,
    text: "Our daughter is in the international program at American Heritage and was selected for a summer study tour in Barcelona. We found out in March that her passport had expired in January — the trip was in June. We thought we had plenty of time, but when we checked the government processing website, it said 10–13 weeks. Fast Passport Center got her passport renewed in five business days. She's in Barcelona right now having the time of her life. Worth every penny.",
    service: "Passport Renewal",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function PlantationTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Plantation Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Plantation, Sunrise, Davie, and central Broward County residents who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}